"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RuleAction;
(function (RuleAction) {
    RuleAction[RuleAction["Add"] = 0] = "Add";
    RuleAction[RuleAction["Remove"] = 1] = "Remove";
    RuleAction[RuleAction["RemoveAll"] = 2] = "RemoveAll";
    RuleAction[RuleAction["Toggle"] = 3] = "Toggle";
})(RuleAction || (RuleAction = {}));
var isA = function (val, type) {
    return typeof val === type;
};
var isString = function (val) {
    return isA(val, "string");
};
var isBool = function (val) {
    return isA(val, "boolean");
};
var toRule = function (name, action) {
    return {
        name: name,
        action: action,
    };
};
var toAddRule = function (name) {
    return toRule(name, RuleAction.Add);
};
var toRemoveRule = function (name) {
    return toRule(name, RuleAction.Remove);
};
var toToggleRule = function (name) {
    return toRule(name, RuleAction.Toggle);
};
exports.classList = function (element) {
    return element.classList;
};
var normalise = function (unnormalised) {
    return unnormalised
        .split("!")
        .join("")
        .split("~")
        .join("");
};
var parseString = function (rule) {
    var action = RuleAction.Add;
    var name = rule;
    if (rule[0] === "^") {
        action = RuleAction.RemoveAll;
        name = "";
    }
    else if (rule[0] === "!") {
        action = RuleAction.Remove;
        name = normalise(name);
    }
    else if (rule[0] === "~") {
        action = RuleAction.Toggle;
        name = normalise(name);
    }
    return {
        action: action,
        name: name,
    };
};
var parseStrings = function (rules) {
    return rules.map(parseString);
};
var applyRules = function (rules, target) {
    var class_list = exports.classList(target);
    var l = rules.length;
    for (var i = 0; i < l; ++i) {
        var rule = rules[i];
        switch (rule.action) {
            case RuleAction.RemoveAll:
                target.className = "";
                class_list = exports.classList(target);
                break;
            case RuleAction.Add:
                class_list.add(rule.name);
                break;
            case RuleAction.Toggle:
                if (class_list.contains(rule.name)) {
                    class_list.remove(rule.name);
                }
                else {
                    class_list.add(rule.name);
                }
                break;
            case RuleAction.Remove:
                class_list.remove(rule.name);
                break;
            default:
                throw new TypeError("Invalid rule action; " + JSON.stringify(rule));
        }
    }
};
var parseClassRules = function (rules) {
    if (isString(rules)) {
        return parseStrings(rules.split(" "));
    }
    else {
        return rules.map(function (rule) {
            if (isString(rule)) {
                return parseString(rule);
            }
            else {
                return rule;
            }
        });
    }
};
exports.classRules = function (raw_rules) {
    var rules = parseClassRules(raw_rules);
    return function (element) {
        applyRules(rules, element);
    };
};
exports.elementClasses = function (element) {
    return function (raw_rules) {
        var rules = parseClassRules(raw_rules);
        applyRules(rules, element);
    };
};
exports.addClasses = function (element) {
    var classes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        classes[_i - 1] = arguments[_i];
    }
    applyRules(classes.map(toAddRule), element);
};
exports.removeAllClasses = function (element) {
    applyRules([{ action: RuleAction.RemoveAll, name: "" }], element);
};
exports.removeClasses = function (element) {
    var classes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        classes[_i - 1] = arguments[_i];
    }
    applyRules(classes.map(toRemoveRule), element);
};
exports.toggleClasses = function (element) {
    var classes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        classes[_i - 1] = arguments[_i];
    }
    applyRules(classes.map(toToggleRule), element);
};
exports.applyClasses = function (target, raw_rules) {
    exports.classRules(raw_rules)(target);
};
exports.hasClass = function (target, class_name) {
    return exports.classList(target).contains(class_name);
};
exports.switchClasses = function (element, switcher) {
    var classes = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        classes[_i - 2] = arguments[_i];
    }
    var result = isBool(switcher) ? switcher : switcher();
    if (result) {
        exports.addClasses.apply(void 0, [element].concat(classes));
    }
    else {
        exports.removeClasses.apply(void 0, [element].concat(classes));
    }
};
